import SolutionBenefitsI18n from "@/components/landing/shared/SolutionBenefitsI18n";
import { TrendingUp, Search, ShoppingCart, Headphones } from "lucide-react";
const EcommerceBenefitsSection = () => <SolutionBenefitsI18n translationPrefix="ecommerceSolution" icons={[TrendingUp, Search, ShoppingCart, Headphones]} />;
export default EcommerceBenefitsSection;
